import React, { useState } from 'react';
import { FaPlusCircle, FaMinusCircle, FaReply } from 'react-icons/fa';
import EditableComment from './EditableComment';
import ProfileImage from './ProfileImage.js';
import ProfileHover from './ProfileHover.js';
import Tooltip from './Tooltip.js';
import { helpers } from '../services/helpers';

function Comment({
  comment,
  onReply,
  setParentHideBefore,
  isLast,
  isRoot,
  expandedComments,
  setExpandedComments,
  newComment,
  setNewComment,
  handleSubmitComment,
  user,
}) {
  const [hideBefore, setHideBefore] = useState(false);
  const [isReplying, setIsReplying] = useState(false);

  const toggleNestedComments = () => {
    if (isLast) {
      setParentHideBefore(!expandedComments[comment.id])
    }
    expandedComments[comment.id] = !expandedComments[comment.id]
    setExpandedComments({ ...expandedComments })
  };

  const handleReply = (e) => {
    setIsReplying(true)
    onReply(comment.id);
  };

  const hideEditableComment = () => {
    setIsReplying(false)
  }

  return (
    <React.Fragment>
      <div className="comment-wrapper" id={`comment-wrapper-${comment.id}`}>
        <div style={{ zIndex: 10 }}>
          <Tooltip content={<ProfileHover profile={comment.patient} />}>
            <ProfileImage
              profile={comment.patient}
              size={30}
            />
          </Tooltip>
        </div>
        <div style={{ flexGrow: '1', marginLeft: '0.5rem' }}>
          <div className={`comment-card ${isRoot ? 'hide-before' : 'show-before'}`}>
            <Tooltip content={<ProfileHover profile={comment.patient} />}>
              <div className="comment-header">
                {comment.patient.username}
              </div>
            </Tooltip>
            <p className="comment-text" style={{ fontWeight: 'normal' }}>{comment.text}</p>
          </div>
          <div className="comment-actions">
            <span className="comment-date">
              {helpers.formatTime(comment.createdAt)}
            </span>
            {comment.nestedComments && comment.nestedComments.length > 0 && (
              <button
                className="show-replies-button"
                onClick={toggleNestedComments}
              >
                {expandedComments[comment.id] ? (
                  <>
                    <FaMinusCircle className="reply-icon" />
                    Hide replies
                  </>
                ) : (
                  <>
                    <FaPlusCircle className="reply-icon" />
                    Show {comment.nestedComments.length} replies
                  </>
                )}
              </button>
            )}
            <button
              className="reply-button"
              onClick={handleReply}
              title="Reply to this comment"
            >
              <FaReply className="reply-icon" />
              Reply
            </button>
          </div>
        </div>
      </div>
      {expandedComments[comment.id] && (
        <div className={`nested-comments ${hideBefore ? 'hide-before' : 'show-before'} ${isLast ? 'last' : ''} ${isRoot ? 'root' : ''}`}>

          {isReplying && (
            <EditableComment
              commentId={comment.id}
              autoFocus={true}
              handleSubmitComment={handleSubmitComment}
              hideSelf={hideEditableComment}
              user={user}
            />
          )}
          {comment && comment.nestedComments && (

            comment.nestedComments.map((nestedComment, index) => (
              <Comment
                setParentHideBefore={setHideBefore}
                key={nestedComment.id}
                comment={nestedComment}
                onReply={onReply}
                isLast={index == comment.nestedComments.length - 1}
                isRoot={false}
                expandedComments={expandedComments}
                setExpandedComments={setExpandedComments}
                newComment={newComment}
                setNewComment={setNewComment}
                handleSubmitComment={handleSubmitComment}
                user={user}
              />
            ))

          )}
        </div>
      )}
    </React.Fragment>
  );
}

export default Comment; 